import React from "react";
import "./ModernModal.css";

const ModernModal = ({
  id,
  title,
  description,
  children,
  buttons = [],
  onClose,
}) => {
  const handleBackgroundClick = (e) => {
    if (e.target.id === id) {
      onClose();
    }
  };

  return (
    <div id={id} className="modern-modal" onClick={handleBackgroundClick}>
      <div className="modern-modal-content">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        {title && <h3 className="modal-title">{title}</h3>}
        {description && <p className="modal-description">{description}</p>}
        {children}
        <div className="modal-actions">
          {buttons.map((btn, index) => (
            <button
              key={index}
              className={`modal-btn ${btn.variant}`}
              onClick={btn.onClick}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModernModal;
